import React ,{useState} from 'react'
import './inland-marine-insurance.scss'
import {
    Hero, MainHeading,
    Breadcrumb, CommonTabs,
    SentryCard, Plans,
    NewsCard, SuccessStories,
    FindAgent,
    PageHeaderIntro
} from '../../../../components';
import { images } from "../../../../utils/customFn";
import { Container } from 'react-bootstrap';

const InlandMarineInsurance = () => {
    const [hrefData, setHrefData] = useState();
    const breadcrumbs = [
        { label: "Sentry Insurance home", link: "/" },
        { label: "What we offer", link: "/what-we-offer" },
        { label: "Insurance products", link: "/what-we-offer/insurance-products" },
        { label: "Commercial property insurance", link: "/what-we-offer/insurance-products/commercial-property-insurance" },
        { label: "Inland marine insurance", link: "/what-we-offer/insurance-products/commercial-property-insurance/inland-marine-insurance" },
    ];

    const activeTabId = "difference";

    const tabsData = [
        {
            id: "difference",
            href: "difference",
            label: "The Sentry difference",
        },
        {
            id: "Ourinlandmarine",
            href: "Ourinlandmarine",
            label: "Our inland marine products",
        },
        {
            id: "help",
            href: "help",
            label: "Who we've helped",
        },
    ];

    const sectrydata = {
        banner: images['two_business_people_looking_at_tablet.avif'],
        heading: 'The Sentry difference',
        subheading: 'Different drivers—different coverages',
        para: 'We’ll work with you to determine what liability insurance coverage is appropriate for your organization. Our goal is to help make sure you’re protected from the actual exposures and risks your business faces.',
        sideheading: 'The right coverage for your business',
        sidepara: 'We draw on our insurance experience and leverage our industry knowledge to help you protect your business and your future.',
        sideImg: images['boots_Blue.svg']
    }
    const plansData = {
        blue_heading: 'Protecting your business with industry knowledge',
        blue_para: 'If you need inland marine insurance coverage, you are protecting valuable assets. No matter the size of your business, we’re here to help you protect your property. We offer different types of inland marine coverages, like contractor’s equipment and tool coverage, so that regardless of the size of your business, we have the coverage for you.',
        purple_icon: images['Icon_of_two_purple_birds.svg'],
        purple_heading: 'Insuring property on the move',
        purple_para: "We’ll help you choose appropriate coverage based on your company’s unique risks.",
    }
    const NewsCardData = [
        {
            id: 1,
            title: 'Commercial auto insurance',
            description:
                'We have the 401(k) and other retirement plan options and services to help you and your employees plan for retirement.',
            linkUrl: '',
            linkText: 'More about commercial auto insurance >',
        },
        {
            id: 2,
            title: 'Dealership auto coverage',
            description: 'Running a business comes with uncertainties. Protect yourself from the unknown with business liability coverage.',
            linkUrl: '/',
            linkText: 'More about dealership auto coverage >',
        },
        {
            id: 3,
            title: 'Commercial auto liability',
            description:
                'Protect your profits and property from the unexpected during a construction or renovation project.',
            linkUrl: '/',
            linkText: 'More about commercial auto liability >',
        },

    ];
    const HeaderData = [
        {
            image: images['Icon-in-blue-of-two-people-outside-trailer-truck.svg'],
            para: 'As a business owner, standard property coverages may not protect your assets while you’re on the move or at a location other than your business address. Our inland marine coverage will help you protect your property and your business if you work at multiple sites, move products or goods, or possess property owned by others.',
        },  
    ];
    return (
        <>
            <div className='inland-marine-insurance'>
                {/* hero section */}
                <Hero img={images["Two_trailer_trucks_driving_down_highway.avif"]} />
                <Container>
                    {/* Breadcrumb */}
                    <Breadcrumb crumbs={breadcrumbs} />
                    {/* heading  */}
                    <MainHeading title="Inland marine insurance" showshare={false} />
                    {/* Tabs */}
                    <CommonTabs tabs={tabsData} activeTab={activeTabId} hrefData={hrefData}
                    setHrefData={setHrefData} />

                    {/* Header intro section */}
                    <PageHeaderIntro Data={HeaderData} heading="" />

                    {/* the sentry card */}
                    {/* <SentryCard data={sectrydata} /> */}
                    {/* Plans section */}
                    <div className='the-sentry-card' id='difference'>
                        <h1>The Sentry difference</h1>
                        <Plans data={plansData} />
                    </div>
                    {/* news card section */}
                    <NewsCard id='Ourinlandmarine' Title="Some of our inland marine products" CardData={NewsCardData} showNavLink={false} subTitle="PRODUCTS" />
                    {/* success stories */}
                    <SuccessStories showSeemore={true} id='help'/>
                    {/* news  */}
                    <NewsCard Title="News and resources" CardData={NewsCardData} showNavLink={false} subTitle="GUIDES" />
                    <FindAgent />
                </Container>
            </div>
        </>
    )
}

export default InlandMarineInsurance